import React from "react";
import { Navigate } from "react-router-dom";
import { isSuperAdminRole } from "../utils/userUtils";

interface SuperAdminProtectedProps {
  children: React.ReactNode;
}

const SuperAdminProtected: React.FC<SuperAdminProtectedProps> = ({
  children,
}) => {
  if (!isSuperAdminRole()) {
    return <Navigate to="/chat-jess" replace />;
  }
  return <>{children}</>;
};

export default SuperAdminProtected;
